import { defineComponent as _defineComponent } from 'vue'

import { watch, onUnmounted, ref } from 'vue'
import { useRouter, onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router'
import { useInriStore } from '../stores/inriStore'
import dialog from '../plugins/dialog'


export default /*#__PURE__*/_defineComponent({
  props: {
  isDirty: {
    type: Boolean,
    default: undefined,
  },
  isDialogOpen: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const privateId = `dirty-check_${Math.random()}`
const dirtyDialogIsOpen = ref(false)
const willRedirect = ref(false)
const router = useRouter()
const inriStore = useInriStore()

watch(() => props.isDirty, value => {
  inriStore.toggleDirtyComponent(privateId, value)
}, { immediate: true })

onUnmounted(() => {
  inriStore.toggleDirtyComponent(privateId, false)
})

onBeforeRouteUpdate((to) => {
  return handleRouteChange(to)
})

onBeforeRouteLeave((to) => {
  return handleRouteChange(to)
})

function handleRouteChange (to) {
  // If a dialog is open then just do nothing (prevent navigation)
  if (props.isDialogOpen) {
    return false
  }

  if (props.isDirty && !willRedirect.value) {
    if (!dirtyDialogIsOpen.value) {
      dirtyDialogIsOpen.value = true
      dialog.confirm({
        title: 'unsaved data',
        text: 'are you sure you want to leave the page without saving your data?',
        confirmButtonText: 'yes',
      }).onOk(() => {
        willRedirect.value = true
        router.push(to)
      }).onDismiss(() => {
        dirtyDialogIsOpen.value = false
      })
      return false
    } else {
      return false
    }
  }
}

return (_ctx: any,_cache: any) => {
  return null
}
}

})